module.exports = __webpack_public_path__ + "img/familymart_logo.backup.54d5310a.svg";